import { teal } from '@mui/material/colors';
import shadow from 'helpers/shadow';
import { makeStyles } from 'tss-react/mui';
import Typography from '@mui/material/Typography';
import AddBoxIcon from '@mui/icons-material/AddBox';
import HelpIcon from '@mui/icons-material/Help';
import Button from '@mui/material/Button';
import Link from 'next/link';
import { useQuery } from '@apollo/client';
import { AI_CREDITS_BALANCE } from '../../helpers/graphql/aiCredits';
import { useEffect } from 'react';

export default function AiCreditsBalance(props) {
  const { data, refetch } = useQuery(AI_CREDITS_BALANCE, {
    ssr: false,
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (props.triggerRefetch) refetch();
  }, [props, refetch]);

  const boxColor = teal[400];
  const borderRadius = 16;
  const useStyles = makeStyles()(() => ({
    rounded: { borderRadius: 16, marginRight: 10 },
    paper: {
      backgroundColor: boxColor,
      boxShadow: shadow.xl,
      borderRadius: 16,
      display: 'flex',
      overflow: 'hidden',
    },
    titleColor: {
      color: 'rgba(256,256,256,0.8)',
      transition: 'width 1s ease-in-out',
      width: '100%',
      height: 20,
    },
    titleColorSmall: {
      color: 'rgba(256,256,256,0.8)',
      transition: 'width 1s ease-in-out',
      width: 0,
      height: 20,
    },
    iconSpan: {
      width: 70,
      backgroundColor: teal[600],
      '&:hover': {
        backgroundColor: teal[700],
      },
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      borderRadius: 0,
    },
    content: {
      padding: '10px',
      backgroundColor: boxColor,
      borderRadius: `0 ${borderRadius}px ${borderRadius}px 0`,
      color: 'white',
    },
    icon: {
      height: 38,
      width: 38,
      maxWidth: '100%',
      color: 'white',
    },
    helpIcon: {
      height: 38,
      width: 38,
      maxWidth: '100%',
    },
  }));

  const { classes } = useStyles();

  const creditBalance = (data && data.aiCreditsBalance) || 0;

  return (
    <div className="m-3 tw-flex tw-flex-row-reverse">
      <div className={classes.paper}>
        <div className={classes.content}>
          <div
            className={
              data && data.aiCreditsBalance
                ? classes.titleColor
                : classes.titleColorSmall
            }
          >
            {data && data.aiCreditsBalance && (
              <Typography color="inherit" variant="h6" component="span">
                {creditBalance >= 1000000
                  ? `${Math.round(creditBalance / 1000000)}M`
                  : creditBalance > 1000
                  ? `${Math.round(creditBalance / 1000)}k`
                  : creditBalance}{' '}
                AI Credits
              </Typography>
            )}
          </div>
        </div>
        <Link href={`/dashboard/aiblogger/credits?open=${props.open}`}>
          <Button className={classes.iconSpan}>
            <AddBoxIcon className={classes.icon} />
          </Button>
        </Link>
      </div>
      <a
        href="https://www.youtube.com/watch?v=A1t6G5m9s7g"
        rel="noopener noreferrer nofollow"
        target="_blank"
      >
        <Button className={classes.rounded} variant="outlined">
          <HelpIcon className={classes.helpIcon} />
        </Button>
      </a>
    </div>
  );
}
